import { render, staticRenderFns } from "./certificateMatchListModal.vue?vue&type=template&id=65d29386&"
import script from "./certificateMatchListModal.vue?vue&type=script&lang=js&"
export * from "./certificateMatchListModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateMatchListModal.vue?vue&type=style&index=0&id=65d29386&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports